<template>
  <div>
    <my-head></my-head>
    <img src="../../assets/Rectangle353.png" style="width: 100%" />
    <div class="financialservice minH">
      <div class="service_title">知识产权质物处置</div>

      <div class="service_content">
        为落实《知识产权金融生态综合试点工作方案》要求，上海知识产权交易中心设置知识产权质物处置专门版块。知识产权质押融资质物处置是指银行、小额贷款公司、融资担保公司、保险公司等金融机构，在知识产权质押融资发生逾期风险后，依法依约对为贷款提供质押的知识产权进行处置的行为。知识产权质物处置是知识产权质押融资的重要环节，对于降低金融机构质押贷款风险，推动知识产权质押融资提质增量，提升转化运用效益具有积极作用。
        <br /><br />
        联系方式：<br />
        卢老师：18616806980<br />
        李老师：13918677300<br />
        <br />
        附件：<a
          class="service_qd"
          :href="downloadUrl"
          download="附件-上海知识产权交易中心知识产权质押融资质物处置指引.pdf"
          >上海知识产权交易中心知识产权质押融资质物处置指引</a
        >
      </div>

      <!-- <div class="service_list flex-between flex-wrap">
        <div
          class="service_col flex-left"
          v-for="(item, index) in serlist"
          :key="index"
        >
          <img :src="item.img" />
          <div>
            <div class="col_title">{{ item.title }}</div>
            <div class="col_fl">费率</div>
            <div class="col_nr">{{ item.fl }}</div>
          </div>
        </div>
      </div> -->

    </div>
    <my-footer></my-footer>
  </div>
</template>

<script>
import MyHead from "../../components/MyHead.vue";
import MyFooter from "../../components/MyFooter.vue";
export default {
  components: { MyHead, MyFooter },
  data() {
    return {
      
    };
  },
  computed: {
    downloadUrl() {
      let url = window.location.href;
      return `${url.split("#")[0]}static/附件-上海知识产权交易中心知识产权质押融资质物处置指引.pdf`;
    },
  },
};
</script>

<style lang="scss">
.financialservice {
  width: 80%;
  margin: 48px auto 60px;
  .service_bottom {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100vw;
    height: 70px;
    background: #f7f8fa;
    box-shadow: 0px -1px 0px 1px #f0f0f0;
    font-size: 16px;
    font-weight: 500;
    color: #1d2129;
    & > div {
      width: 80%;
      .service_qd {
        font-size: 14px;
        margin-left: 16px;
        font-weight: 400;
        color: #165dff;
        cursor: pointer;
      }
      .service_sq {
        background: #165dff;
        border-radius: 4px;
        width: 163px;
        height: 36px;
        font-size: 14px;
        font-weight: 500;
        color: #ffffff;
        border: none;
      }
    }
  }
  .service_list {
    padding-bottom: 80px;
    .service_col {
      width: 48%;
      padding: 32px;
      background: linear-gradient(180deg, #f7f8fa 0%, #ffffff 49%);
      border-radius: 12px 12px 12px 12px;
      border: 1px solid #e5e6eb;
      margin-bottom: 24px;
      .col_nr {
        font-size: 16px;
        padding: 4px 8px;
        font-weight: 500;
        color: #c37d3a;
        line-height: 24px;
        background: linear-gradient(
          90deg,
          #fff3dd 0%,
          #fff3dd 26%,
          #ffffff 100%
        );
        border-radius: 4px;
        opacity: 1;
        border: 1px solid;
      }
      .col_fl {
        font-size: 14px;
        font-weight: 400;
        color: #86909c;
        line-height: 22px;
        margin-bottom: 2px;
      }
      .col_title {
        font-size: 20px;
        font-weight: 500;
        color: #1d2129;
        line-height: 28px;
        margin-bottom: 12px;
      }
      img {
        width: 50px;
        margin-right: 30px;
      }
    }
  }
  .list_top {
    width: 100%;
    background: linear-gradient(180deg, #f7f8fa 0%, #ffffff 49%);
    border-radius: 12px;
    border: 1px solid #e5e6eb;
    padding: 34px;
    margin-bottom: 24px;
    .top_content {
      .top_nr {
        font-size: 13px;
        font-weight: 400;
        color: #4e5969;
        line-height: 22px;
      }

      .top_yh {
        font-size: 16px;
        font-weight: 500;
        color: #c37d3a;
        padding: 4px 8px;
        background: linear-gradient(
          90deg,
          #fff3dd 0%,
          #fff3dd 26%,
          #ffffff 100%
        );
        border-radius: 4px;
        border: 1px solid;
        margin-bottom: 16px;
      }

      .top_fl {
        font-size: 14px;
        font-weight: 400;
        color: #86909c;
        line-height: 22px;
        margin-bottom: 2px;
      }

      .top_title {
        font-size: 20px;
        font-weight: 500;
        color: #1d2129;
        line-height: 28px;
        margin-bottom: 12px;
      }
    }
    img {
      width: 50px;
      margin-right: 20px;
      position: relative;
    }
  }
  .service_title_1 {
    font-size: 20px;
    font-weight: 500;
    color: #1d2129;
    line-height: 28px;
    margin-bottom: 24px;
    a {
      font-size: 14px;
      font-weight: 400;
      color: #165dff;
      line-height: 22px;
    }
  }
  .service_content {
    font-size: 14px;
    font-weight: 400;
    color: #4e5969;
    line-height: 28px;
    margin-bottom: 32px;
  }
  .service_title {
    font-size: 24px;
    font-weight: bold;
    color: #1d2129;
    line-height: 32px;
    margin-bottom: 24px;
  }
}
</style>
